module.exports = __webpack_public_path__ + "static/national-map-6f2da27183c918e91dd90c2d4910fd28.svg";